import { render, staticRenderFns } from "./integralRuleDiv.vue?vue&type=template&id=4b13b95e&scoped=true"
import script from "./integralRuleDiv.vue?vue&type=script&lang=js"
export * from "./integralRuleDiv.vue?vue&type=script&lang=js"
import style0 from "./integralRuleDiv.vue?vue&type=style&index=0&id=4b13b95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13b95e",
  null
  
)

export default component.exports